var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24097 0.680099L5.97409 0L7.33429 1.46624L6.60117 2.14634L4.06467 4.49938H11.5148H12.5148V6.49938H11.5148H4.0164L6.59511 8.85238L7.3338 9.52642L5.98573 11.0038L5.24703 10.3298L0.802894 6.27464L0 5.54202L0.796833 4.80282L5.24097 0.680099Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlack);
export default __webpack_public_path__ + "static/media/arrow-left-black.9a0a08f9fdc1b2c574228c16fbbcd479.svg";
export { ForwardRef as ReactComponent };